import instance from "@/services/apiService";
import apiUrls from "@/services/apiUrls";
import store from "@/store";

const state = {
  salon: [],
};

const getters = {
  salon: (state) => state.salon,
};

const actions = {
  async getSalon({ commit }) {
    store.commit("showLoading", true);
    try {
      const response = await instance.get(apiUrls.SALON);
      commit("getSalon", response.data);
    } catch (error) {
      console.log(error);
    }
    store.commit("showLoading", false);
  },
};

const mutations = {
  getSalon(state, payload) {
    state.salon = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
